import { ProgressData } from "../../../../../services/assistant";
import { WorkoutAnalysisProgress } from "./WorkoutAnalysisProgress";

interface WorkoutDescriptionInputProps {
  readonly description: string;
  readonly onDescriptionChange: (value: string) => void;
  readonly disabled: boolean;
  readonly progress?: ProgressData;
}

export function WorkoutDescriptionInput({
  description,
  onDescriptionChange,
  disabled,
  progress,
}: WorkoutDescriptionInputProps) {
  return (
    <div className="space-y-3 sm:space-y-4">
      <div>
        <label
          htmlFor="workout-description"
          className="mb-2 sm:mb-3 block text-xs sm:text-sm font-bold text-gray-700 dark:text-gray-300"
        >
          Descrição do Treino
        </label>
        <textarea
          id="workout-description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Ex: Criar um treino de hipertrofia para iniciante, 3 vezes por semana. Treino A: peito e tríceps, Treino B: costas e bíceps, Treino C: pernas e ombros. Usar exercícios básicos com 3 séries de 10-12 repetições."
          className="w-full min-h-[150px] sm:min-h-[200px] rounded-xl border border-stroke bg-white px-4 sm:px-5 py-3 sm:py-4 text-sm sm:text-base font-medium text-gray-900 outline-none transition focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 dark:border-strokedark dark:bg-form-input dark:text-white dark:focus:border-purple-500"
          disabled={disabled}
        />
        <p className="mt-2 text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">
          Descreva o tipo de treino, frequência, grupos musculares e objetivos.
          A IA buscará exercícios na base e criará o plano completo.
        </p>
        {progress && (
          <div className="mt-4">
            <WorkoutAnalysisProgress progress={progress} />
          </div>
        )}
      </div>
    </div>
  );
}
